<template>
  <div :style='{width:width}' class="datetime-picker icon-calendar icon-triangle-down" @click='calendarClicked($event)' :class="{disabled: disabled}">
    <div>
      <input type='text' id='tj-datetime-input' :value="date" :name='name' @click='toggleCal' autocomplete='off' :disabled="disabled"/>
      <div ref="calendar" class='calendar-div' :class='{noDisplay: hideCal}'>
        <div class="month-list" v-show="showSelectList">
          <table class="table">
            <tbody>
              <tr v-for="(value, index) in 6" :key="index">
                <td width="25%" :class="{'selected': monthIndex === index}">
                  <a @click="setMonth(index)">{{miMonths[index]}}</a>
                </td>
                <td width="25%" class="right-col" :class="{'selected': monthIndex === (index+6)}">
                  <a @click="setMonth(index+6)">{{miMonths[index+6]}}</a>
                </td>
                <td width="25%" v-if="index === 0" class="td-center">
                  <div class="calendar-l icon-arrow_left" @click="changeLeftYear">
                  </div>
                </td>
                <td width="25%" v-if="index === 0" class="td-center">
                  <div class="calendar-r icon-arrow_right" @click="changeRightYear">
                  </div>
                </td>
                <td width="25%" v-if="index !== 0" :class="{'selected': year === (selYear+index-4)}">
                  <a v-if="selYear+index-4 >= 2000 && selYear+index-4 <= 2037" @click="setYear(selYear+index-4)">{{selYear+index-4}}</a>
                </td>
                <td width="25%" v-if="index !== 0" :class="{'selected': year === (selYear+index+1)}">
                  <a v-if="selYear+index+1 >= 2000 && selYear+index+1 <= 2037" @click="setYear(selYear+index+1)">{{selYear+index+1}}</a>
                </td>
              </tr>
              <tr style="background-color: #D8D8D8;border-top: 1px solid #AFAFAF;">
                <td colspan="2">
                  <button type='button' class="selBtn" style="float:right" @click='onOkClick'>Ok</button>
                </td>
                <td colspan="2">
                  <button type='button' class="selBtn" style="float:left" @click='showSelectList=false'>{{$t('cancel')}}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div :class='{noDisplay: hideDate}'>
          <div class='calendar-header'>
            <div class="calendar-l icon-arrow_left" @click="leftMonth"></div>
            <div class='year-month-wrapper'>
              <div class='month-setter' @click='showSelectList=true'>{{month}}</div>
            </div>
            <div class="calendar-r icon-arrow_right" @click="rightMonth"></div>
            <div class="calendar-l icon-arrow_left" @click="leftYear"></div>
            <div class='month-wrapper month-setter' @click='showSelectList=true'>{{year}}</div>
            <div class="calendar-r icon-arrow_right" @click="rightYear"></div>
          </div>
          <div class='headers'>
            <span class='days' v-for="(port, index) in days" :key="index">{{port}}</span>
          </div>
          <div>
            <span  class="port" v-for="(port, index) in ports" :key="index" :class='{activePort: index === activePort, today: index === today}' @click='setDay(index, port)'>{{port}}</span>
          </div>
        </div>
        <div class='today-btn' @click='setToday'>{{$t('today')}}</div>
        <!-- <button type='button' @click='setDate' class='okButton'>OK</button> -->
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import moment from 'moment'
export default {
  name: 'datetime-picker',
  props: ['format', 'name', 'width', 'value', 'isDisabled'],
  data () {
    return {
      date: this.value,
      hideCal: true,
      activePort: null,
      today: null,
      timeStamp: moment(new Date()),
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      miMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      monthIndex: 0,
      hourIndex: 0,
      minuteIndex: 0,
      year: 2019,
      portsHolder: [],
      minute: '00',
      hour: '01',
      day: 1,
      minuteSelectorVisible: false,
      hourSelectorVisible: false,
      period: 'AM',
      selYear: 2019,
      showSelectList: false,
      disabled: false
    }
  },
  watch: {
    value: function (value) {
      if (this.value) {
        try {
          this.timeStamp = moment(this.value, this.format)
        } catch (e) {
          this.$log.debug(e)
        }
      }
      this.year = this.timeStamp.year()
      this.selYear = this.timeStamp.year()
      this.monthIndex = this.timeStamp.month()
      this.day = this.timeStamp.date()

      this.updateCalendar()
      this.setDate()
    },
    format: function (value) {
      this.setDate()
    },
    hideCal: function (value) {
      if (!value) {
        let windowH = window.innerHeight
        let cursorH = event.clientY
        if (windowH - cursorH > 236) {
          this.$refs.calendar.style.marginTop = '3px'
        } else {
          this.$refs.calendar.style.marginTop = '-268px'
        }
      }
    },
    isDisabled: {
      handler (value) {
        this.disabled = value
      },
      immediate: true
    }
  },
  methods: {
    leftMonth () {
      let index = this.months.indexOf(this.month)
      if (index === 0) {
        this.monthIndex = 11
      } else {
        this.monthIndex = index - 1
      }
      this.updateCalendar()
    },
    rightMonth () {
      let index = this.months.indexOf(this.month)
      if (index === 11) {
        this.monthIndex = 0
      } else {
        this.monthIndex = index + 1
      }
      this.updateCalendar()
    },
    rightYear () {
      this.year++
      this.updateCalendar()
    },
    leftYear () {
      if (this.year > 2000) {
        this.year--
        this.updateCalendar()
      }
    },
    updateCalendar () {
      let date = new Date(this.year, this.monthIndex, 1, 0, 0, 0)
      let day = date.getDay()
      let daysInMonth = new Date(this.year, this.monthIndex + 1, 0).getDate()
      let ports = []
      let portsLenght = 35
      if (day === 6 || (day === 5 && daysInMonth === 31)) {
        portsLenght = 42
      }
      let activeFound = false
      for (let i = 0; i < portsLenght; i++) {
        let j = i - day
        let curr = (j < 0 || j >= daysInMonth) ? '' : j + 1
        ports.push(curr)
        if (curr === this.day && this.timeStamp.month() === this.monthIndex && this.timeStamp.year() === this.year) {
          this.activePort = i
          this.today = i
          activeFound = true
        }
      }
      if (!activeFound) {
        this.activePort = -1
      }
      this.ports = ports
    },
    setToday () {
      this.timeStamp = moment(new Date())
      this.year = this.timeStamp.year()
      this.monthIndex = this.timeStamp.month()
      this.day = this.timeStamp.date()
      this.updateCalendar()
      this.setDate()
    },
    setYear (year) {
      this.year = year
    },
    setMonth (month) {
      this.monthIndex = month
    },
    setDay (index, port) {
      if (port !== '') {
        this.activePort = index
        this.day = port
        this.timeStamp = moment(new Date(this.year, this.monthIndex, this.day))
        this.setDate()
      }
    },
    setMinute (index, closeAfterSet) {
      this.minuteIndex = index
      this.minute = this.minutes[index]
      if (closeAfterSet) {
        this.minuteSelectorVisible = false
      }
    },
    setHour (index, closeAfterSet) {
      this.hourIndex = index
      this.hour = this.hours[index]
      if (closeAfterSet) {
        this.hourSelectorVisible = false
      }
    },
    showHourSelector () {
      this.hourSelectorVisible = true
      this.minuteSelectorVisible = false
    },
    showMinuteSelector () {
      this.minuteSelectorVisible = true
      this.hourSelectorVisible = false
    },
    keyIsDown (event) {
      let key = event.which || event.keycode
      if (key === 38) {
        if (this.minuteSelectorVisible && this.minuteIndex > 0) {
          this.setMinute(this.minuteIndex - 1, false)
          this.scrollTopMinute()
        } else if (this.hourSelectorVisible && this.hourIndex > 0) {
          this.setHour(this.hourIndex - 1, false)
          this.scrollTopHour()
        }
      } else if (key === 40) {
        if (this.minuteSelectorVisible && this.minuteIndex < this.minutes.length - 1) {
          this.setMinute(this.minuteIndex + 1, false)
          this.scrollTopMinute()
        } else if (this.hourSelectorVisible && this.hourIndex < this.hours.length - 1) {
          this.setHour(this.hourIndex + 1, false)
          this.scrollTopHour()
        }
      } else if (key === 13) {
        this.minuteSelectorVisible = false
        this.hourSelectorVisible = false
      }
      if (this.minuteSelectorVisible || this.hourSelectorVisible) {
        event.preventDefault()
        this.minuteSelectorVisible = false
        this.hourSelectorVisible = false
      }
    },
    scrollTopMinute () {
      let mHeight = this.$refs.minuteScroller.scrollHeight
      let wHeight = this.$refs.minuteScrollerWrapper.clientHeight
      let top = mHeight * (this.minuteIndex / (this.minutes.length - 1)) - (wHeight / 2)
      this.$refs.minuteScroller.scrollTop = top
    },
    scrollTopHour () {
      let mHeight = this.$refs.hourScroller.scrollHeight
      let wHeight = this.$refs.hourScrollerWrapper.clientHeight
      let top = mHeight * (this.hourIndex / (this.hours.length - 1)) - (wHeight / 2)
      this.$refs.hourScroller.scrollTop = top
    },
    changePeriod () {
      this.period = this.period === 'AM' ? 'PM' : 'AM'
    },
    calendarClicked (event) {
      if (event.target.id !== 'j-hour' && event.target.id !== 'j-minute') {
        this.minuteSelectorVisible = false
        this.hourSelectorVisible = false
      }
      event.cancelBubble = true
      if (event.stopPropagation) {
        event.stopPropagation()
      }
    },
    documentClicked (event) {
      if (event.target.id !== 'tj-datetime-input') {
        this.hideCal = true
      }
    },
    toggleCal () {
      this.hideCal = !this.hideCal
    },
    setDate () {
      let d = null
      if (!this.format) {
        this.$log.info('Invalid date format supplied')
      } else {
        let h = this.hour + ''
        if (h === '12') {
          if (this.period === 'AM') {
            h = '00'
          } else {
            h = '12'
          }
        } else if (this.period === 'PM') {
          h = parseInt(h) + 12
          h = '' + h
        }
        d = this.format
        d = d.replace('YYYY', this.year)
        d = d.replace('DD', this.day < 10 ? '0' + this.day : this.day)
        let m = this.monthIndex + 1
        d = d.replace('MM', m < 10 ? '0' + m : m)
        this.minute += ''
        d = d.replace('h', h.length < 2 ? '0' + h : '' + h)
        d = d.replace('i', this.minute.length < 2 ? '0' + this.minute : '' + this.minute)
        d = d.replace('s', '00')
        this.$emit('input', d)
        this.date = d
        this.hideCal = true
      }
      this.showSelectList = false
    },
    changeRightYear () {
      if (this.selYear <= 2030) {
        this.selYear = this.selYear +10
      }
    },
    changeLeftYear () {
      if (this.selYear > 2003) {
        this.selYear = this.selYear - 10
      }
    },
    onOkClick () {
      this.updateCalendar()
      this.showSelectList = false
    },
    onCancelClick () {
    }
  },
  created () {
    if (this.value) {
      try {
        this.timeStamp = moment(this.value, this.format)
      } catch (e) {
        this.$log.debug(e)
      }
    }
    this.$log.debug(this.timeStamp)
    this.year = this.timeStamp.year()
    this.selYear = this.timeStamp.year()
    this.monthIndex = this.timeStamp.month()
    this.day = this.timeStamp.date()
    this.hour = this.timeStamp.hour()
    this.hour = this.hour < 10 ? '0' + this.hour : '' + this.hour
    this.minute = this.timeStamp.minute()
    this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute

    this.updateCalendar()
    document.addEventListener('keydown', this.keyIsDown)
    document.addEventListener('click', this.documentClicked)
    this.setDate()
  },
  destroyed: function () {
    document.removeEventListener('keydown', this.keyIsDown)
    document.removeEventListener('click', this.documentClicked)
  },
  computed: {
    ports: {
      get: function () {
        let p = []
        if (this.portsHolder.length === 0) {
          for (let i = 0; i < 42; i++) {
            p.push('')
          }
        } else {
          p = this.portsHolder
        }
        return p
      },
      set: function (newValue) {
        this.portsHolder = newValue
      }
    },
    month () {
      return this.months[this.monthIndex]
    },
    dateTime () {
      return this.timeStamp.year() + '-' + (this.timeStamp.month() + 1) + '-' + this.timeStamp.date()
    },
    minutes () {
      let arr = []
      for (let i = 0; i < 60; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i)
      }
      return arr
    },
    hours () {
      let arr = []
      for (let i = 1; i <= 12; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i)
      }
      return arr
    },
    dateFormat () {
      let f = 'YYYY-MM-DD'
      let allowedFormats = [
        'YYYY-MM-DD', 'YYYY.MM.DD', 'YYYY-MM-DD', 'MM/DD/YYYY', 'MM.DD.YYYY', 'MM-DD-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY', 'DD-MM-YYYY'
      ]
      if (this.format) {
        f = this.format
      }
      if (allowedFormats.indexOf(f) < 0) {
        this.$log.info('Invalid date format supplied')
        return null
      } else {
        return f
      }
    },
    hideTime () {
      return this.dateFormat.indexOf('h:i:s') === -1
    },
    hideDate () {
      return this.dateFormat === 'h:i:s'
    }
  }
}
</script>

<style lang="scss" scoped>

  .calendar-header {
    display: flex;
    font-size: 14px;
    color: #000000;
    text-align: left;
    line-height: 22px;
    height: 22px;
    margin-bottom: 10px;
  }
  .headers {
    font-size: 14px;
    color: #9B9B9B;
    text-align: center;
    line-height: 16px;
  }
  .year-month-wrapper{
    display: flex;
    height: 22px;
    background-color: #FFF;
    width: 70px;
    /* border-bottom: 1px solid #b9b9b9; */
  }
  .datetime-picker{
    position: relative;
    input{
      cursor: pointer;
      width:100%;
      height: 30px;
      padding: 3px;
      background: #FFFFFF;
      border: 1px solid #979797;
      border-radius: 4px;
      color: #7F7F7F;
      box-shadow: none;
      outline-style: none;
      display: inline-block;
      font-size: 12px;
      margin: auto;
      padding: 0px 30px 0px 30px;
      &:focus {
        box-shadow: none;
        border: 1px solid #4A90E2;
        color: #000000;
      }
      &:active {
        box-shadow: none;
        border: 1px solid #2F2F2F;
        color: #000000;
      }
      &:disabled {
        cursor: not-allowed;
        box-shadow: none;
        border: 1px solid #AEAEAE;
        color: #AEAEAE;
      }
    }
    &.icon-triangle-down{
      &:after {
        content: '\E967';
        cursor: pointer;
        position: absolute;
        pointer-events: none;
        width: 20px;
        height: 20px;
        top: 5px;
        right: 10px;
      }
      &.disabled {
        color: #AEAEAE;
      }
    }
    &.disabled::before {
      color: #AEAEAE;
    }
    &::before {
      content: '\E913';
      pointer-events: none;
      position: absolute;
      font-size: 14px;
      width: 14px;
      height: 14px;
      margin-left: 12px;
      margin-top: 8px;
      // color: #7f7f7f;
    }
  }
  .calendar-div {
    background-color: #fff;
    width: 246px;
    height: 236px;
    border: 1px solid #b9b9b9;
    box-shadow: 1px 2px 5px #ccc;
    position: fixed;
    left: initial;
    top: initial;
    margin-top: 3px;
    padding: 10px 27px 20px 27px;
    font-size: 12px;
    color: #000000;
    text-align: left;
    line-height: 22px;
    z-index: 2;
  }
  .port, .days {
    display: inline-block;
    width: calc(100% / 7);
    height: 24px;
    line-height: 24px;
    text-align: center;
    vertical-align: middle;
    font-size: 14px;
    color: #4C4C4C;
  }
  .today {
    color: #b8292d;
    font-size: 12px;
  }
  .port {
    cursor: pointer;
  }
  .days {
    height: 16px;
    vertical-align: middle;
    font-size: 14px;
    color: #9B9B9B;
    text-align: center;
    line-height: 16px;
  }
  .port:hover{
    background-color: #EDF6FC;
    height: 24px;
    border-radius: 50%;
    font-size: 14px;
    color: #4C4C4C;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
  }
  .activePort, .activePort:hover {
    background-color: #4875F5;
    height: 24px;
    border-radius: 50%;
    text-align: center;
    line-height: 24px;
    font-size: 15px;
    color: #FFFFFF;
    line-height: 24px;
  }
  .month-setter, .year-setter{
    margin: auto;
    display: inline-block;
    cursor: pointer;
  }
  .month-wrapper {
    margin: 0px;
  }
  .nav-l:hover, .nav-r:hover {
    color: #b9b9b9;
  }
  .nav-l, .nav-r {
    display: inline-block;
    width: 6px;
    height: 6px;
    color: #b9b9b9;
    font-size: 12px;
    cursor: pointer;
    border: 0;
    margin:0;
  }
  .nav-l{
    float: left;
  }
  .nav-r{
    float: right;
  }
  .month {
    width: 40px;
    color: #2f2f2f;
    font-size: 14px;
  }
  .year{
    width: 40px;
    margin-left: 5px;
    margin-right: 10px;
    color: #2f2f2f;
    font-size: 14px;
  }
  .hour-selector, .minute-selector{
    width: 30px;
    display: inline-block;
    text-align: center;
    font-weight: 500;
    position: relative;
    cursor: pointer;
  }
  .time-separator{
    display: inline-block;
    font-weight: 500;
  }
  .time-picker{
    margin: 10px
  }
  .nav-t, .nav-d{
    font-weight: 500;
    cursor: pointer;
  }
  .scroll-hider {
    display: none;
    vertical-align:top;
    overflow:hidden;
    border:0;
    position: absolute;
    top: -40px;
    left: 0;
    box-shadow: 0 0 3px #333;
    background-color: white;
  }
  .scroll-hider ul {
    padding:5px;
    margin:-5px -13px -5px -5px;
    list-style-type: none;
    height: 100px;
    overflow: auto;
    width:55px;
    color: #999;
    overflow-x: hidden;
  }
  .showSelector{
    display:inline-block;
  }
  li.active{
    background-color: #ed4d00;
    color: white;
  }
  li{
    padding: 4px;
    font-size: 16px;
    width: 100%;
    cursor: pointer;
  }
  .time-picker{
    display: inline-block;
  }
  .noDisplay{
    display: none;
  }
  .okButton{
    color: #ed4d00;
    font-size: 15px;
    font-weight: 500;
    padding: 0;
    float: right;
    border: 0;
    margin-right: 10px;
    margin-top: 10px;
    cursor: pointer;
    background: transparent;
  }
  .today-btn {
    cursor: pointer;
    height: 22px;
    font-size: 12px;
    color: #fff;
    border: 1px solid #969696;
    background-color: #787878;
    text-align: center;
    line-height: 22px;
    &:hover {
      background-color: #787878;
    }
    &:active {
      background-color: #00b0ff;
    }
  }
  .month-list {
    position: absolute;
    background: #fff;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 20;
    table {
      width: 100%;
      height: 100%;
      tbody {
        tr {
          td {
            height: calc(100% / 7);
            padding: 2px;
            border-top: none;
            vertical-align: middle;
            a {
              display: block;
              padding: 2px 4px;
              text-decoration: none;
              text-align: center;
              outline: 0 none;
              font-size: 11px;
              color: #333;
              cursor: pointer;
            }
            &.selected {
              background-color: #D8D8D8;
              border-color: #DCDCDC;
            }
            &.td-center {
              text-align: center;
            }
          }
          .right-col {
            border-right: 1px solid #D7D7D7;
          }
          .selBtn {
            text-align: center;
            text-decoration: none !important;
            border: 1px solid;
            padding: 1px 3px 1px;
            cursor: pointer;
            background-color: #4E565F;
            color: #fff;
            border-color: #C0C0C0 #434343 #434343 #C0C0C0;
          }
        }
      }
    }
  }
  .calendar-l, .calendar-r {
    display: inline-block;
    cursor: pointer;
    margin: 3px 0px;
    padding: 0px 5px;
    font-size: 16px;
    color: #7F7F7F;
  }
</style>



// WEBPACK FOOTER //
// src/components/module/DateTimePicker.vue